//interface

export const translations = {
  close: "סגור",
  DriveDescription: "תאור הנסיעה",
  DriveTimes: "זמני הנסיעה",
  OverlapingDrives: "חפיפה בין זמני הנסיעות",
  EditDrive: "עריכת נסיעה",
  connectedPreferences: " הזמנות מקושרות",
  All: "הכל",
  ShmiraList: "רשימת שמירה",
  Preference: "העדפת שמירה",
  Preferences: "העדפות",
  Nesia: "שמירה",
  Name: "שם",
  NameWhatIsMyName: "איך קוראים לי",
  Rename: "שנה שם",
  MyProfile: "החשבון שלי",
  ExportAllData: "יצוא הכל",
  downloadAsCSV: "הורדה כטבלה",
  ImportAllData: "יבוא הכל",
  ImportFromSheets: "יבוא מטופס שמירה",
  ImportFromSheetsApprove: "יבוא נתונים ",
  ImportFromSheetsPastSuccess:
    "נמצאו נתונים תקינים, האם ליבא את הנתונים לתוך רשימת השמירה החדשה ?",
  ImportFromSheetsPastFail:
    "לא ניתן ליבא את הנתונים, שימו לב שהנתונים בגליון תקינים, ושהעתקתם את כל הגליון",
  ImportFromSheetsPastValidating: "הנתונים נבדקים, נא להמתין...",
  DeleteAndImportAllData: "מחק הכל והחלף ביבוא הכל",
  ImportPart: "יבוא חלקי",
  NewName: "שם חדש",
  PastHere: "הדבק כאן את הטקסט",
  PastHereSheet: "הדבק כאן את תוכן הגליון",
  NewShmiraList: "רשימת שמירה חדשה",
  ManageAllSidrurim: "ניהול רשימות שמירה",
  Delete: "מחק",
  ExportToFile: "יצא לקובץ",
  help: "עזרה",
  ImportFromFile: "יבא מקובץ",
  ImportPreferences: "יבוא העדפות שמירה",
  ChooseFile: "בחר קובץ",
  Archive: "העברה לארכיון",
  MoveToActive: "העברה לסידורים פעילים",
  MoveToTrash: "העברה לאשפה",
  DeleteForever: "מחיקה לנצח",
  CreateCopy: "צור עותק",
  Hour: "שעה",
  From: "מ",
  Until: "עד",
  toWhere: "למקום",
  Where: "מקום",
  addLocation: "הוסף מקום",
  Start: "התחלה",
  Finish: "סיום",
  FromDate: "מתאריך",
  ToDate: "לתאריך",
  TypeOfInfoPreference: "הגבלת שמירה",
  Tsamud: "צמוד",
  CanGuardIn: "יכול לשמור רק בימים",
  CantGuardIn: "לא יכול לשמור בימים ",
  CanGuardInDays: "יכול לשמור רק בימים",
  CantGuardInDays: "לא יכול לשמור בימים",
  CanAlwaysGuard: "יכול לשמור בכל הימים",
  CantGuardInDaysDates: "לא יכול לשמור בתאריכים",
  CanGuardInDaysDates: "יכול לשמור בתאריכים",
  CanAlwaysGuardDates: "יכול לשמור בכל בתאריכים",

  CanGuardInDaysShort: "רק בימים",
  CantGuardInDaysShort: "רק לא בימים",
  CanAlwaysGuardShort: " יכול לשמור בכל הימים",
  TsamudWord: "צמוד",
  OneWayTo: "הסעה",
  exampleVideo: "הסבר כיצד ליבא",
  OneWayFrom: "איסוף",
  TwoWay: "הלוך חזור",
  Submit: "סיום ",
  Advanced: "מתקדם ",
  AddPreference: "הוסף שומר ",
  Comments: "הערות ",
  Approve: "אישור",
  Cancel: "ביטול",
  CreateSketch: "צור סקיצה חדשה",
  CreateLocationGroup: "צור בסיס סידור חדש",
  NoSketchMessage:
    'לא קיימות סקיצות לרשימת השמירה, לאחר הזנת כל ההעדפות ניתן ללחוץ על "יצירת סקיצה חדשה"',
  SingleGuardMessage: 'סקציה זו היא במצב "שומר אחד בלילה"',
  SingleGuardMessageDetails:
    'נעשה שיבוץ של שומר אחד בלבד ללילה. אם יש רק שומר אחד בלילה, הלילה לא מוגדר כ"חסר" ולא מופיעות הצעות לשבץ שומרים ללילות שיש בהן שומר',
  NewPreference: "שומרת חדשה",
  PendingPreferences: "הזמנות לטיפול",
  GuardsNoAssigned: "שומרים ללא שיבוץ",
  CopyOf: "(עותק)",
  Trash: "אשפה",
  inArchive: "ארכיון",
  vehicles: "רכבים",
  AddVehicles: "הוסף רכב",
  Add: "הוסף",
  seats: "מושבים",
  halfOrFull: "נוסעים",
  flexibilityByDays: "גמישות",
  byDates: "תאריכים",
  dateSingle: "תאריך",
  daySingle: "יום",
  byWeekDays: "ימות השבוע",
  missingDetails: "מידע חלקי",
  nameExist: "השם נמצא יותר מפעם אחת ",

  withoutGuard: "ללא שיבוץ",
  noPotentialPlacesFound: "לא נמצאו ימים מתאימים לשיבוץ.",

  onePassenger: "נוסע/ת אחד/ת",
  halfNight: "רגילה - חצי לילה",
  fullNight: "כפולה - כל הלילה",
  halfNightBrief: " חצי לילה",
  fullNightBrief: "כפולה - כל הלילה",

  none: "אין",
  exitTime: "יציאה",
  flexEarly: "הקדמה",
  min: "דק'",
  flexLate: "איחור",
  exitTimeToPickup: "יציאה לאיסוף",
  returnTime: "חזרה",
  pickupTime: " בשעה",
  toLocation: " אל  ",
  Locations: "מקומות",
  roadTracks: "מסלולים",
  PublicTransport: 'חלופות תחב"צ',
  fromLocation: "מ",
  fromLocationWithThe: "מה",
  inLocation: "ב",
  toLocationLe: "ל",
  Sketch: "סקיצה",
  oneGuard: "שומר אחד",
  twoGuards: "שני שומרים",
  LocationBase: "מיקום הסידור",
  ActiveShmiraListim: "סידורים פעילים",
  number: "מספר",
  first: "ראשונה",
  second: "שנייה",
  third: "שלישית",
  action: "פעולה",
  moerActions: "פעולות נוספות",
  assignIn: "שיבוץ ",
  SketchActionRemove: "סמן כטופלה",
  SaveToThisComputer: "שמירה למחשב זה",
  hello: "שלום",
  SketchActionMerge: "מזג עם נסיעה אחרת",
  SketchActionSplit: "פיצול להסעה ואיסוף",
  SketchActionChange: "שינוי נסיעה",
  SketchActionChangeTime: "שינוי שעות של נסיעה קיימת",
  SketchActionReplaceExisting: "העבר לרכב במקום נסיעה קיימת",
  SketchActionPublicTransport: 'צור פתרון בתחב"צ',
  removeFromThisNight: "הסרה",
  guards: "שומרים",
  guardsAction: "שומר ",
  daysBefore: "ימים לפני",
  daysAfter: "ימים אחרי",
  guardsTheSameNight: "כבר שומר באותו לילה",
  guardDates: "ימי שמירה",
  minimumBetweenDates: "ימים לפחות בין שמירות",
  peopleWhoCanGuard: "יכולים לשמור",
  missingGuard: "חסר",
  details: "פרטים",

  /* date errors  */
  dateErrStartBiggerthan: "על תאריך ההתחלה להיות לפני תאריך הסיום",
  moreThan90days: "על טווח התאריכים להיות בין 10 ל 100 ימים",
};
